import { ErrorMessage, Field } from 'formik';
import React from 'react';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';

const MultiDynamicExtraSetting = ({
  validateRefCollectionId,
  collectionOptions,
  values,
  getSelectFieldUseAsOption,
  getFieldOption,
}) => {
  const collectionOptionsArray = collectionOptions().map((optionElement) => ({
    label: optionElement.props.children,
    value: optionElement.props.value,
  }));

  const fieldOptionsArray =
    values.refCollection && getFieldOption(values.refCollection.collectionName)
      ? getFieldOption(values.refCollection.collectionName).map((optionElement) => ({
          label: optionElement.props.children,
          value: optionElement.props.value,
        }))
      : [];

  return (
    <>
      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
        <CustomInputWithIcon icon="diagram-2" extraCss="bmd-form-group">
          <Field name="refCollection.collectionName" validate={validateRefCollectionId}>
            {({ field, form, meta }) => (
              <>
                <CustomSelect
                  name={field.name}
                  value={field.value}
                  options={collectionOptionsArray}
                  placeholder="Select a Collection *"
                  onChange={(name, value) => form.setFieldValue(name, value)}
                />
                {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
              </>
            )}
          </Field>
        </CustomInputWithIcon>
      </div>

      {values.refCollection && (
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
          <CustomInputWithIcon icon="diagram-2" extraCss="bmd-form-group">
            <Field name="refCollection.collectionField" validate={validateRefCollectionId}>
              {({ field, form, meta }) => (
                <>
                  <CustomSelect
                    name={field.name}
                    value={field.value}
                    options={fieldOptionsArray}
                    placeholder="Select field name for display records *"
                    onChange={(name, value) => form.setFieldValue(name, value)}
                  />
                  {meta.touched && meta.error && <p className="errors">{meta.error}</p>}
                </>
              )}
            </Field>
          </CustomInputWithIcon>
        </div>
      )}

      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 pl-5">
        {getSelectFieldUseAsOption(values)}
      </div>
    </>
  );
};

export default MultiDynamicExtraSetting;
